export default __webpack_public_path__ + "static/media/library.b0618dbd.svg";